import { UserContext } from "@contexts/User";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import styles from "../Navbar.module.scss";

function replaceParams(url, params = null) {
  let newUrl = url;
  if (params) {
    const paramKeys = Object.keys(params);
    paramKeys.forEach((key) => {
      newUrl = newUrl.replace(`:${key}`, params[key]);
    });
  }

  return newUrl;
}

const NavbarList = ({ navItems, unansweredEvent }) => {
  const { t } = useTranslation();
  const { setShowBroadcastModal, showBroadcastModal } =
    useContext(UserContext);
  const location = useLocation();
  const currentPage = location.pathname.split("/")[1];

  const setActiveSvg = (name) => {
    if (currentPage === name) {
      return "text-dawn-gray";
    }
    return "text-sonic-silver";
  };

  const setTextClass = (name) => {
    if (currentPage === name) {
      return "text-dawn-gray";
    }
    return "text-sonic-silver";
  };

  return navItems?.map((item) => (
    <Link
      key={item.name}
      to={replaceParams(item.path, item?.params)}
      data-navigation-guide={item.name}
      className={clsx(
        "group duration-100 w-full flex flex-col items-center relative",
        styles.navItemLink,
        (item.name === currentPage ||
          (currentPage === "" && item.name === "home")) &&
          "bg-pampas",
      )}
      onClick={() => setShowBroadcastModal(!showBroadcastModal)}
    >
      <div>
        <item.icon
          {...(item.name === "messages"
            ? {
                isActiveTab: !!(
                  item.name === currentPage ||
                  (currentPage === "" && item.name === "home")
                ),
              }
            : {})}
          {...(item.name === "appointments" ? { unansweredEvent } : {})}
          className={clsx(
            "group-hover:text-dawn-gray fill-current text-sonic-silver menu-icon",
            styles.menuIcon,
            setActiveSvg(item.name),
            "transition",
          )}
        />
      </div>
      <span
        className={clsx(
          "group-hover:text-opacity-100 font-medium-poppins capitalize",
          styles.navItemText,
          "transition text-opacity-80",
          setTextClass(item.name),
        )}
      >
        {t(`navbar.${item.name}.title`)}
      </span>
    </Link>
  ));
};

export default NavbarList;
